export const LOMAVIS_POST_APPROVAL = 'lomavisPostApproval';
export const SINGLE_STEP = 'single_step';
export const TWO_STEP = 'two_step';
export const PUBLISH = 'publish';
export const SAVE_AS_APPROVED_POST = 'save_as_approved_post';
export const USER = 'user';
export const GROUP = 'group';
// export const STEP_1 = 'step_1';
// export const STEP_2 = 'step_2';

export const STEP_1 = 1;
export const STEP_2 = 2;

export const STATUS_DRAFT = 1;
export const STATUS_ACTIVE = 2;
export const STATUS_DONE = 3;
export const STATUS_START_PROCESS = 99;

export const CONFIG = 'config';
export const POST = 'post';

export const RIGHT_COLUMN_USERS = 'users';
export const RIGHT_COLUMN_PROGRESS = 'progress';

export const STATUS_CHOICES = {
  STATUS_ACTIVE: 'Active',
  STATUS_DRAFT: 'Draft',
  STATUS_DONE: 'Done'
};

export const STEP_MODE_SINGLE_STEP = 1;
export const STEP_MODE_MULTI_STEP = 2;

export const CONFIG_SELECT_OPTIONS = {
  CONFIG,
  POST
};

export const RIGHT_COLUMN_OPTIONS = {
  RIGHT_COLUMN_USERS,
  RIGHT_COLUMN_PROGRESS
};

export const STEP_MODE_CHOICES = {
  STEP_MODE_SINGLE_STEP: 'Single Step',
  STEP_MODE_MULTI_STEP: 'Multi Step'
};

export const TARGET_PUBLISH_WITH_SCHEDULE = 1;
export const TARGET_SAVE_AS_APPROVED_POST = 2;

export enum TableSelectOption {
  USER = 'user',
  GROUP = 'group',
}

export const TARGET_CHOICES = {
  TARGET_PUBLISH_WITH_SCHEDULE: 'Publish with Schedule',
  TARGET_SAVE_AS_APPROVED_POST: 'Save as Approved Post'
};

export const APPROVAL_STEP_MODE_USER = 1;
export const APPROVAL_STEP_MODE_GROUP = 2;

export const APPROVAL_STEP_MODE_CHOICES = {
  APPROVAL_STEP_MODE_USER: 'User',
  APPROVAL_STEP_MODE_GROUP: 'Group'
};

export const APPROVAL_USERS_RULE_ALL = 1;
export const APPROVAL_USERS_RULE_ANY = 2;

export const APPROVED: 'approved' = 'approved';
export const EMPTY: 'empty' = 'empty';
export const REJECTED: 'rejected' = 'rejected';

export const APPROVAL_DECISIONS = {
  APPROVED,
  EMPTY,
  REJECTED
} as const;
export const TARGET_TEXT_SAVE_AS_APPROVED_POST =
  'lomavisPostApproval.approvalTarget.saveAsApproved';
export const TARGET_TEXT_PUBLISH_WITH_SCHEDULE =
  'lomavisPostApproval.approvalTarget.publishWithSchedule';